var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// Generated by `npm run icon`, don't modify this file
import React from 'react';
import Base from './_base';
const Inbox = props => {
    const { className = null } = props, other = __rest(props, ["className"]);
    return (<Base viewBox="0 0 16 16" className={`cuk2-icon-inbox ${className}`} {...other}>
      <g>
        <path d="M13 1.5a1 1 0 01.928.629l2 5a.97.97 0 01.064.242L16 7.5v6a1 1 0 01-.883.993L15 14.5H1a1 1 0 01-.993-.883L0 13.5v-6c0-.088.011-.173.032-.254l.04-.117 2-5A1 1 0 013 1.5h10zm-8.874 7H1.5V13h13V8.5h-2.627l-.043.155C11.314 10.227 9.822 11.5 8 11.5c-1.816 0-3.278-1.292-3.83-2.84l-.044-.16zM12.5 3h-9L1.9 7h2.7c.7 0 .925.543 1 1 .181 1.11 1.295 2 2.4 2 1.054 0 2.22-.89 2.4-2 .073-.45.338-1 1-1h2.7l-1.6-4z" fillRule="evenodd"/>
      </g>
    </Base>);
};
export default Inbox;
